var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.82715,170.82947l-39.999,39.99316c-.02.02051-.04443.03369-.06542.05323a4.02318,4.02318,0,0,1-.54346.44384c-.10254.06836-.21338.11573-.32031.17383a2.30861,2.30861,0,0,1-.77784.3208c-.11328.03321-.22119.07715-.33789.1001a3.91936,3.91936,0,0,1-1.56689,0c-.1167-.02344-.2251-.06689-.33838-.1001a3.90555,3.90555,0,0,1-.4082-.127,4.00944,4.00944,0,0,1-.38184-.20117c-.102-.05567-.208-.10059-.30615-.166a4.04019,4.04019,0,0,1-.61182-.5l-39.998-39.99853a3.99975,3.99975,0,0,1,5.65674-5.65625L180,198.33728V111.99353a4,4,0,0,1,8,0v86.34473l33.1709-33.167a4.00026,4.00026,0,0,1,5.65625,5.6582ZM119.999,123.99353H48a4,4,0,0,0,0,8h71.999a4,4,0,0,0,0-8Zm-71.999-56H183.999a4,4,0,0,0,0-8H48a4,4,0,1,0,0,8Zm56,120H48a4,4,0,0,0,0,8h56a4,4,0,0,0,0-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort-ascending.df5092c8c2b333c0d1d4ca37ca76ddc2.svg";
export { ForwardRef as ReactComponent };